<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn color="primary" align="right" @click="addNew">
          Thêm Danh mục
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="newPostConfigs"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.is_sale="{ item }">
            <div class="d-flex justify-center">
              <v-checkbox
                :input-value="item.is_sale"
                @change="updateSale(item.id)"
              ></v-checkbox>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item.id)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-col>

      <!--      dialog-->
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_NEW_POST_CONFIG, DELETE_DETAIL_NEW_POST_CONFIG, UPDATE_SALE_NEW_POST_CONFIG } from "@/store/modules/confignew";

export default {
  data() {
    return {
      headers: [
        { text: "STT", value: "id" },
        { text: "Tên", value: "name" },
        { text: "Loại danh mục khuyến mại", value: "is_sale", align: 'center'},
        { text: "Actions", value: "actions" },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      newPostConfigs: "newPostConfigs",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_NEW_POST_CONFIG}`, {});
  },
  methods: {
    addNew() {
      this.$router.push("/manage_page/Page_manager/add_new_post_config");
    },
    editItem(item) {
      this.$router.push({
        path: "/manage_page/Page_manager/edit_new_post_config/" + item.id,
      });
    },
    deleteItem(id){
        confirm("Bạn có chắc muốn xóa?") &&
        this.$store.dispatch(`${DELETE_DETAIL_NEW_POST_CONFIG}`, id).then((data) => {
          if (data && data.status === 1) {
            this.$store.dispatch(GET_NEW_POST_CONFIG);
          }
        });
    },
    updateSale(id){
      this.$store.dispatch(UPDATE_SALE_NEW_POST_CONFIG, {id: id}).then((data) => {
          if (data.data && data.data.status === 1) {
            this.$store.dispatch(GET_NEW_POST_CONFIG);
          }
        });
    }
  },
};
</script>